import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyCreateWeddingForm = loadable(() => import(/* webpackChunkName: "content/createwedding-form" */ './CreateWeddingForm'), 'CreateWeddingForm');
